import(/* webpackMode: "eager", webpackExports: ["MarketingPricingTable"] */ "/vercel/path0/apps/web/app/(marketing)/_components/marketing-pricing-table.tsx");
